'use client';
/**
 * 홈 「오늘 숫자 띠 + 분양 임박 현장」 — 지역 선택을 따른다.
 *   서버·첫 수화 = 전국(검색엔진이 보는 HTML 그대로). 지역이 정해지면(useHomeRegion ready) 그 지역 묶음으로 갈아 그린다.
 *   지역 확정 전에는 data-kd-hr-dep 로 자리만 두고 가린다(다른 지역 줄이 번쩍이지 않게 · home-region.css 규칙).
 *   지역에 임박 일정이 없으면 다른 지역 현장을 채우지 않고 한 줄 안내 + 그 지역 허브 링크.
 */
import React from 'react';
import TodayStrip, { type TodayStripCounts } from './TodayStrip';
import ImminentRows from './ImminentRows';
import { useHomeRegion } from './HomeRegionFilter';
import type { ImminentLink } from '@/lib/home/imminent-links';
import type { ThumbData } from '@/lib/thumb/resolve';
import { pickRegionToday, type RegionTodayBundle } from '@/lib/home/today-by-region';

export interface HomeTodayImminentProps {
  nationalStrip: TodayStripCounts;
  nationalRows: readonly ImminentLink[];
  byRegion: Record<string, RegionTodayBundle>;
  thumbs: Record<string, ThumbData>;
  today: string;
}

export default function HomeTodayImminent({ nationalStrip, nationalRows, byRegion, thumbs, today }: HomeTodayImminentProps) {
  const st = useHomeRegion();
  if (st.status !== 'ready') {
    return (
      <div data-kd-hr-dep="">
        <TodayStrip counts={nationalStrip} today={today} />
        <ImminentRows rows={nationalRows} thumbs={thumbs} title="전국 분양 임박 현장" />
      </div>
    );
  }
  const label = st.data.label;
  const pick = pickRegionToday(byRegion, label);
  return (
    <div data-home-today-region={pick.sido ?? ''}>
      {pick.strip ? <TodayStrip counts={pick.strip} today={today} /> : null}
      {pick.rows.length ? (
        <ImminentRows rows={pick.rows} thumbs={thumbs} title={`${label} 분양 임박 현장`} />
      ) : (
        <section className="kd-home-imm" aria-labelledby="kd-home-imm-h" data-cl-section="imminent">
          <div className="ds2-wrap">
            <div className="kd-home-imm__head">
              <h2 id="kd-home-imm-h" className="kd-home-imm__h">{label} 분양 임박 현장</h2>
              <a className="kd-home-imm__more" href={st.data.hubHref || '/apt'}>{label} 현장 전체 →</a>
            </div>
            <p className="kd-home-imm__empty">두 달 안에 일정이 잡힌 현장이 아직 없습니다. 일정이 확인되면 여기에 바로 올라옵니다.</p>
          </div>
        </section>
      )}
    </div>
  );
}
